import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  link: {
    textDecoration: "none",
    borderRadius: "8px", // Rounded edges

    "&:hover": {
      backgroundColor: "#F0F4FF", // Light blue background for active item
      borderRadius: "8px", // Rounded edges
      "& .MuiListItemText-primary": {
        color: "#42497E", // Blue text for active item
        fontWeight: 600, // Bold text for active item
      },
    },
  },
  linkActive: {
    backgroundColor: "#F0F4FF",
  },
  linkNested: {
    marginTop: theme.spacing(0.5),
    "&:hover": {
      backgroundColor: "#F0F4FF", // Light blue background for active item
      borderRadius: "8px", // Rounded edges
      "& .MuiListItemText-primary": {
        color: "#42497E", // Blue text for active item
        fontWeight: 600, // Bold text for active item
      },
    },
  },
  linkNestedActive: {
    paddingLeft:"15px",
    backgroundColor: "#F0F4FF", // Light blue background for active item
    borderRadius: "8px", // Rounded edges
    "& .MuiListItemText-primary": {
      color: "#42497E", // Blue text for active item
      fontWeight: 600, // Bold text for active item
    },
   
  },
  linkIcon: {
    marginRight: theme.spacing(0),
    color: "#344054",
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: "#42497E",
  },
  linkText: {
    padding: 0,
    color: "#344054",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
    fontWeight: 600,

  },
  linkTextActive: {
    color: "#42497E",
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 30,
  },
  onFocusStyles:{paddingLeft:"15px"},
  sectionTitle: {
    marginLeft: theme.spacing(2.5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));